<template>
<vs-card >
     <vs-row>
            <vs-col class="w-1/2">
                <h4 style="margin-left:20%">Prescriptions
                      <router-link :to="{path:'/prescription',query:{patientId:patientId,opId:opId}}" style="color:#009696;">
                     <feather-icon icon="FilePlusIcon" class="custom-class"  style="padding-left:20px"></feather-icon>
                      </router-link>
                </h4>
                
            </vs-col>
            <vs-col class="w-1/2">
                <router-link :to="{path:'/patientTray',query:{patientId:patientId}}" style="margin-left:90%">
                    <feather-icon icon="XIcon" class="custom-class"></feather-icon>
                </router-link>
            </vs-col>
        </vs-row>
         <vs-divider></vs-divider>
    <div class="opDashboard" style="padding-left:10%;padding-right:30%">
        
            <ag-grid-vue style="border:1px solid #e2dada" :gridOptions="gridOptions" class="ag-theme-material w-100 h-50 ag-grid-table" :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="rowData" :floatingFilter="true" @grid-ready="onGridReady" :pagination="true" :paginationPageSize="paginationPageSize" :suppressPaginationPanel="true" :frameworkComponents="frameworkComponents">
            </ag-grid-vue>
            <vs-pagination :total="totalPages" :max="maxPageNumbers" v-model="currentPage" />
       
    </div>
</vs-card>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
import { Datepicker } from "../components/Datepicker.vue";
import { FileTextIcon} from 'vue-feather-icons';
export default {
    components: {
        AgGridVue
    },
    data() {
        return {
            patientId:'',
            opId:'',
            refTypeId:'',
            frameworkComponents: {
                agDateInput: Datepicker
            },
            gridOptions: {
                enableBrowserTooltips: true,
                onFilterChanged: this.onGridReady,
                rowModelType: 'infinite',
                onRowDoubleClicked: this.navigate,
                rowSelection: "single",
                floatingFiltersHeight: 40,
                rowStyle: {
                    'text-align': 'left',
                    'cursor': 'pointer'
                }
            },
            maxPageNumbers: 5,
            gridApi: null,
            defaultColDef: {

                sortable: false,
                resizable: true,
                filter: true,
                suppressMenu: true,

                floatingFilterComponentParams: {
                    suppressFilterButton: true
                },
                filterParams: {
                    newRowsAction: 'keep',

                }

            },
            columnDefs: [{
                    headerName: 'Date',
                    field: 'prescriptionDate',
                    cellStyle: {
                        'text-align': 'center'
                    },
                    filter: "agDateColumnFilter",
                    // width: 79,
                    width: 196,
                    tooltipValueGetter: (params) => {
                        return 'Double click to view OP'
                    }
                },
                {
                    headerName: 'Patient Problem',
                    field: 'patientProblem',
                    filter: true,
                    cellStyle: {
                        'text-align': 'center'
                    },
                    filterParams: {
                        newRowsAction: 'keep',
                        
                    },
                    // width: 145,
                    width: 603,
                    tooltipValueGetter: (params) => {
                        return 'Double click to view OP'
                    }
                },
                
            ],
            rowData: null,
        }
    },
     computed: {
        paginationPageSize() {
            if (this.gridApi) return this.gridApi.paginationGetPageSize()
            else return 8
        },
        totalPages() {
            if (this.gridApi) return this.gridApi.paginationGetTotalPages()
            else return 0
        },
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                else return 1
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1);
                this.onGridReady();
            }
        }
    },
     beforeMount() {
        if (this.$route.query.patientId && this.$route.query.opId && this.$route.query.refType) {
            this.patientId = this.$route.query.patientId;
            this.opId = this.$route.query.opId;
            this.refTypeId = this.$route.query.refType;
        }
     },
    mounted() {
        this.gridApi = this.gridOptions.api;
        this.gridApi.sizeColumnsToFit();
    },

    methods: {

        onGridReady(params) {
            this.gridApi.showLoadingOverlay();
            window.addEventListener("resize", function () {
                setTimeout(function () {
                    params.api.sizeColumnsToFit();
                }, 500);
            });
            var request = {
                companyId: this.$session.get('companyId'),
                patientId:this.patientId,
                opId:this.opId,
                refTypeId:this.refTypeId,
                currentPage: this.gridApi.paginationGetCurrentPage() + 1,
                limit: this.gridApi.paginationGetPageSize(),
                filter: this.gridApi.getFilterModel()
            }
            var datasource = {
                getRows: (params) => {
                    this.$http.post(
                        "v2/getPrescriptionDashboardDetails",
                        JSON.stringify(request), {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        }).then(response => {
                        params.successCallback(response.data.data, response.data.recordsTotal);
                        this.gridApi.hideOverlay();

                    });

                }
            }
            
            this.gridApi.setDatasource(datasource);
        },

         navigate() {
            var selectedrow = this.gridApi.getSelectedRows();
            var selectedPrescriptionId = "";
           
        
            selectedrow.forEach((value) => {
                selectedPrescriptionId=value.PrescriptionId;
               
            })
             this.$router.push({
                  path: 'prescription',
                            query: {
                                patientId: this.patientId,
                                opId: opId,
                                 refType:refTypeId
                            }
            })
        }
      
    }
}

</script>

<style>
.ag-header-cell-label {
    justify-content: center;
}
</style>


